import { HashRouter, Route } from 'react-router-dom'
import SiderDemo from './pages/meanLayout'
import './app.scss'

function App() {
  return (
    <div className="App">
      <HashRouter>
      <Route
          path={'/'}
          component={SiderDemo}
        />
      </HashRouter>
    </div>
  )
}

export default App;
